import { ThemeProvider } from '@mui/material';
import AppRoute from './appRoute';
import { SystemStateBoundary } from './lib/entitlementUi';
import { ToastContainer } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import { theme } from './theme';

const ENT_CONFIG = {
  productName: 'Centilio Sign',
  accountsBaseUrl: process.env.REACT_APP_ACCOUNT,
  imageUrl: (process.env.REACT_APP_IMAGE_URL || '') + 'error-img.svg',
};

function App() {

  const CloseButton = ({ closeToast }) => (
    <div
      className="close-icons"
      onClick={closeToast}
    >
      <CloseIcon fontSize="small" />
    </div>
  );

  return (
    <>
      <ToastContainer
        position='top-right'
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        closeButton={CloseButton}
        pauseOnFocusLoss
        icon={false}
        draggable
        pauseOnHover={true}
        theme='light'
      />
      <ThemeProvider theme={theme}>
        <SystemStateBoundary config={ENT_CONFIG}><AppRoute /></SystemStateBoundary>
      </ThemeProvider>
    </>
  );
}

export default App;
